export default {"src":"/_next/static/media/logo.d19c1ce4.svg","height":287,"width":350,"blurWidth":0,"blurHeight":0};